import { useEffect, useState } from 'react';
import L from 'leaflet';
import { isSewer } from '../lib/profiles';
import { pipeLatLngs } from '../lib/model';
import { CLS_COLOR, worstCls } from '../lib/sewerInsp';

const KEY = 'giss_zk';
export const zkOn = () => localStorage.getItem(KEY) === '1';
export const setZkOn = (v) => { localStorage.setItem(KEY, v ? '1' : '0'); window.dispatchEvent(new Event('giss-zk')); };
export function useZkOn() {
  const [on, setOn] = useState(zkOn);
  useEffect(() => { const h = () => setOn(zkOn()); window.addEventListener('giss-zk', h); return () => window.removeEventListener('giss-zk', h); }, []);
  return on;
}

// sewer condition map: every section coloured by its worst condition class (ZK 0 red … 5 green), not inspected = grey dashed
export default function useZkLayer(mapRef, pipes, fittings, t) {
  const on = useZkOn();
  useEffect(() => {
    const map = mapRef.current;
    if (!map || !on || !isSewer()) return undefined;
    const g = L.layerGroup((pipes || []).filter((p) => p.type === 'sewer').map((p) => {
      const w = worstCls(p.insp), pts = pipeLatLngs(p, fittings);
      return L.polyline(pts, { color: w == null ? '#94a3b8' : CLS_COLOR[w], weight: 12, opacity: 0.55, dashArray: w == null ? '8 8' : null, interactive: false, className: `zk-line zk-${w ?? 'none'}` });
    })).addTo(map);
    const leg = L.control({ position: 'bottomright' });
    leg.onAdd = () => { const d = L.DomUtil.create('div', 'zk-legend'); d.dataset.testid = 'zk-legend'; d.innerHTML = `<b>${t.zkLegend}</b>${CLS_COLOR.map((c, i) => `<span><i style="background:${c}"></i>${t.siCls} ${i}</span>`).join('')}<span><i class="none"></i>${t.zkNone}</span>`; return d; };
    leg.addTo(map);
    return () => { g.remove(); leg.remove(); };
  }, [mapRef, pipes, fittings, on, t]);
}
